import React, { useState, useEffect } from 'react';
import WmsSidebar from '../../components/WmsSidebar';
import WmsTopbar from '../../components/wms_topbar';
import logoamerisa from '../../assets/logoamerisa.png';

const WmsDashboard = () => {
  const [activeItem, setActiveItem] = useState('dashboard');
  const [userName, setUserName] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          window.location.href = '/login';
          return;
        }
        const response = await fetch(`${process.env.REACT_APP_API_URL}/me`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error('Error al obtener la información del usuario');
        const userData = await response.json();
        setUserName(userData.name);
      } catch (error) {
        window.location.href = '/login';
      }
    };
    fetchUserInfo();
  }, []);

  return (
    <div className="flex">
      {/* Sidebar drawer solo en móvil */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
      <div
        className={`fixed z-50 inset-y-0 left-0 transition-transform duration-300 md:hidden ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
        style={{ width: '256px', minHeight: '100vh' }}
      >
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      {/* Sidebar estático solo en desktop, en el flujo normal */}
      <div className="hidden md:flex">
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      <div className="flex-1 bg-gray-100 min-h-screen md:p-6">
        <WmsTopbar rightContent={
          <button
            className="md:hidden p-2 ml-2"
            onClick={() => setSidebarOpen(true)}
            aria-label="Abrir menú"
            style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}
          >
            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1="3" y1="12" x2="25" y2="12"/><line x1="3" y1="6" x2="25" y2="6"/><line x1="3" y1="18" x2="25" y2="18"/></svg>
          </button>
        } />
        <div className="w-full flex flex-col items-center justify-center" style={{ minHeight: 'calc(100vh - 80px)' }}>
          {userName && (
            <div className="text-center">
              <h2 className="text-4xl font-bold text-sky-900 mb-2">
                ¡Bienvenido, <span className="text-orange-500">{userName}</span>!
              </h2>
              <p className="text-xl text-gray-600">
                Esperamos que tengas un gran día en tu almacén.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WmsDashboard;
